<template lang="pug">
  .navbar__search-results(v-if="showSearchResults")
    transition(name="fade", mode="out-in")
      ul.navbar__search-results__suggestions(v-if="showSearchSuggestions", key="suggestions")
        li.navbar__search-results__suggestions__title Suggested Search Terms
        li.navbar__search-results__suggestions__item(v-for="suggestion in searchResults", :key="suggestion")
          a(href="#", @keydown.tab="tabOut(suggestion)", @click.prevent="$emit('selected', suggestion)") {{ suggestion }}
      .navbar__search-results__results(v-else-if="search.length > 0", key="results")
        p.navbar__search-results__results__title
          | Suggested Products {{ searchResultsCount }}
          a(:href="getSearchURL") See All
        .navbar__search-results__results__products
          .navbar__search-results__results__item(v-for="product in searchResults.slice(0, 3)", :key="product.id")
            product-tile(:product="product", :horizontal="true")
</template>

<script>
  import Fuse from 'fuse.js';
  import { mapState } from 'vuex';
  import { allProductsHandle } from 'scripts/config/collections.js';

  import storeCollection from 'scripts/mixins/storeCollection.js';

  import ProductTile from 'scripts/components/product/ProductTile.vue';

  export default {
    name: 'NavbarSearchResults',
    mixins: [
      storeCollection,
    ],
    components: {
      ProductTile,
    },
    props: {
      search: String,
      suggestions: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      searchResults () {
        if (!this.collection) return [];

        const query = this.search.toLowerCase();
        const fuse = new Fuse(this.collection.products, {
          tokenize: true,
          keys: ['title', 'keywords'],
        });

        return fuse.search(query);
      },
      searchResultsCount () {
        const showing = Math.min(this.searchResults.length, 3);
        return `(Showing ${showing} of ${this.searchResults.length})`;
      },
      showSearchSuggestions () {
        return this.search.length === 0 && this.suggestions.length > 0;
      },
      showSearchResults () {
        if (!this.search) return false;
        return this.search.length > 0 || this.suggestions.length > 0;
      },
      getSearchURL () {
        return `/search?q=${this.search}`;
      }
    },
    methods: {
      tabOut (suggestion) {
        let lastSuggestion = this.suggestions[this.suggestions.length - 1];

        if (suggestion === lastSuggestion) {
          this.$emit('close-results');
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .navbar__search-results {
    display: none;
    position: absolute;
    top: calc(100%);
    left: 0;
    right: 0;
    padding: 18px;
    background-color: $color-white;

    @include tablet-up {
      display: block;
    }

    &__suggestions {
      list-style: none;
      margin: 0 auto;
      padding: 0;
      border-top: none;

      &__title {
        font-weight: bold;
        font-size: rem(14);
        line-height: 1.28;
        margin-bottom: $grid-gutter;
      }

      &__item {
        font-size: rem(16);
        line-height: 1.4735;

        &:not(:last-child) {
          margin-bottom: 9px;
        }

        > a:hover {
          color: $color--primary;
        }
      }
    }

    &__results {
      width: 100%;

      &__title {
        margin: 0 0 $grid-gutter;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: rem(14);
        line-height: 1.28;
        font-weight: 400;
        font-family: $font-gibson;
        color: $color-indigo;
      }

      &__products {
        > .row {
          justify-content: center;

          @include desktop-up {
            justify-content: flex-start;
          }
        }

        .column {
          padding-bottom: 0;
        }
      }

      &__item:not(:last-child) {
        border-bottom: 1px solid $border--lightest;
      }
    }
  }
</style>
